import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class ScrollTextAnimation {
  constructor(el) {
    this.dom = {el: el};
    this.dom.stc = this.dom.el.querySelector('[data-js="stc"]');
    this.direction = this.dom.el.dataset.direction;

    gsap.registerPlugin(ScrollTrigger);

    this.mql = window.matchMedia('screen and (min-width: 768px)');
    this.checkBreakPoint = this.checkBreakPoint.bind(this);

    this.init();
  }

  init() {
    gsap.set(this.dom.el, {
      x: (this.direction === '-') ? `${this.direction}100%` : `0%`
    })

    // ブレイクポイントの瞬間に発火
    this.mql.addListener(this.checkBreakPoint);
    // 初回チェック
    this.checkBreakPoint(this.mql);
  }

  checkBreakPoint(_mql) {
		if (!_mql.matches) {
      // console.log('sp');
      gsap.to(this.dom.el, {
        x: (this.direction === '-') ? `${this.direction}0%` : `${this.direction}80%`,
        // rotation: 360,
        duration: 4,
        scrollTrigger: {
          trigger: this.dom.stc,
          start: 'top 90%',
          end: 'top 60%',
          // toggleActions: 'play none none reverse',
          toggleActions: 'play pause resume reset',
          markers: false,
          id: 'endless',
          // scrub: true,
          scrub: 1.8 // smoothing
        }
      })
  
      return;
    } else {
      // console.log('pc');
      gsap.to(this.dom.el, {
        x: (this.direction === '-') ? `${this.direction}0%` : `${this.direction}100%`,
        // rotation: 360,
        duration: 4,
        scrollTrigger: {
          trigger: this.dom.stc,
          start: 'top 85%',
          end: 'top 50%',
          toggleActions: 'play none none reverse',
          // toggleActions: 'play pause resume reset',
          markers: false,
          id: 'endless',
          // scrub: true,
          scrub: 1.8 // smoothing
        }
      })
  
      return;
		}
	}
}

export default ScrollTextAnimation